export default __webpack_public_path__ + "static/media/3-steps-to-meaningful-motion-design.18ca063c.mp4";